import { ActionReducer, createReducer, INIT, on, UPDATE } from '@ngrx/store';
import { ApplicationActions } from '@src/suite/common/store/navigation/actions/application.actions';
import { ApplicationState } from '@src/suite/common/store/navigation/models/application.models';

export const initialState: ApplicationState = {
    sessionInitialized: false,
    jwtToken: null,
};

export function applicationMetaReducer(reducer: ActionReducer<ApplicationState>): ActionReducer<ApplicationState> {
    return (state, action) => {
        try {
            let nextState = state;
            if (action.type === INIT || action.type === UPDATE) {
                if (!state?.jwtToken) {
                    nextState = { ...nextState, jwtToken: localStorage.getItem('jwtToken') || '' };
                }
            }
            return reducer(nextState, action);
        } catch (error) {
            console.error('Unhandled error in application store: ', error);
            return state;
        }
    };
}

export const applicationReducer = createReducer(
    initialState,
    on(ApplicationActions.sessionInitialized, (state): ApplicationState => {
        return { ...state, sessionInitialized: true };
    }),
    on(ApplicationActions.setJWTToken, (state, action): ApplicationState => {
        return { ...state, jwtToken: action.jwtToken };
    }),
    on(ApplicationActions.removeJWTToken, (state): ApplicationState => {
        return { ...state, jwtToken: '' };
    })
);
